import axios from "axios";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { server } from "../../server";
import { Link, useLocation } from "react-router-dom";

function StudentAttendance() {
  const { state } = useLocation();
  const [admissionNo, setAdmissionNo] = useState(
    () => state?.admissionNo || ""
  );
  const [studentData, setStudentData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [studentAttendance, setStudentAttendance] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const recordsPerPage = 10;

  const handleSearch = async (e) => {
    if (e && e.preventDefault) e.preventDefault();

    if (!admissionNo) {
      toast.error("Enter Admission No", { position: "top-right" });
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const studentResponse = await axios.post(
        `${server}/getParticularStudentMongodb`,
        { admission_no: admissionNo },
        {
          headers: {
            Authorization: `${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      const studentData = studentResponse.data?.["body-json"]?.body?.student;

      if (studentData) {
        setStudentData(studentData);
      } else {
        toast.error("Wrong Admission No", { position: "top-right" });
        setStudentData(null);
      }
    } catch (err) {
      console.error("Search Error:", err);
      setError("Error fetching data.");
      setStudentData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (admissionNo.length === 5) {
      handleSearch();
    }
  }, [admissionNo]);

  const fetchBookIssueReturn = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${server}/student_attendence_by_admissionno`,
        { admission_no: admissionNo },
        {
          headers: { Authorization: `${localStorage.getItem("token")}` },
        }
      );
      const responseData = response.data?.["body-json"]?.body?.attendance;
      if (Array.isArray(responseData)) {
        setStudentAttendance(responseData);
      } else {
        console.error("Unexpected API Response Format:", response.data);
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (studentData) {
      fetchBookIssueReturn();
    }
  }, [studentData]);

  // Filter
  const filteredRecords = studentAttendance.filter((attendance) => {
    const searchLower = searchTerm.toLowerCase();

    return Object.values(attendance).some((value) => {
      if (typeof value === "string") {
        return value.toLowerCase().includes(searchLower);
      } else if (typeof value === "object" && value !== null) {
        return Object.values(value).some(
          (subValue) =>
            typeof subValue === "string" &&
            subValue.toLowerCase().includes(searchLower)
        );
      }
      return false;
    });
  });

  // ✅ Reset pagination when searching
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  // ✅ Apply pagination AFTER filtering
  const totalPages = Math.ceil(filteredRecords.length / recordsPerPage);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredRecords.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );

  // Page Navigation
  const nextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  return (
    <>
      <div id="db-wrapper">
        <main id="page-content">
          {!studentData && (
            <>
              <div className="">
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-lg-12 col-md-12 col-12">
                      <div class="m-3 mb-1 py-1 d-flex justify-content-between align-items-center">
                        <div className="d-flex">
                          <div class="d-flex align-items-center">
                            <span
                              onClick={() => window.history.back()}
                              class="back-button me-3 cursor-pointer"
                            >
                              <i className="bi bi-arrow-left fs-3"></i>
                            </span>
                            <nav aria-label="breadcrumb">
                              <h4 className="m-0 lh-sm">Student Attendance</h4>
                              <ol class="breadcrumb pe-3 lh-sm">
                                <li class="breadcrumb-item">
                                  <a href="#">Attendance</a>
                                </li>
                                <li
                                  class="breadcrumb-item active"
                                  aria-current="page"
                                >
                                  Student Attendance
                                </li>
                              </ol>
                            </nav>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <section className="mx-3 bg-light">
                <div className="container-fluid">
                  <div className="col-lg-5 col-md-8 col-12">
                    <div className="row align-items-center justify-content-center bg-white p-4 rounded-4">
                      <div className="d-flex flex-column">
                        <div className="d-flex flex-column gap-1">
                          <h1 className="fw-medium mb-0 fs-4 lh-1">
                            Enter Admission No.
                            <br />
                            <span className="mb-0 text-secondary fw-normal fs-5">
                              Admission No. to retrieve the student's academic &
                              library details.
                            </span>
                          </h1>
                        </div>
                        <div className="col-7 mt-3">
                          <form
                            className="d-flex align-items-center"
                            onSubmit={handleSearch}
                          >
                            <span className="position-absolute ps-4">
                              <i className="bi bi-person fs-4" />
                            </span>
                            <input
                              type="search"
                              value={admissionNo}
                              autoFocus
                              onChange={(e) => setAdmissionNo(e.target.value)}
                              className="form-control ps-7 fs-5 lg-search-box"
                              maxLength={5}
                              placeholder="Enter Admission No"
                            />
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </>
          )}

          {studentData && (
            <div className="mt-1">
              <div class="container-fluid my-3 px-3">
                <div className="row g-2">
                  <div className="col-lg-8">
                    <div class="table-responsive border-0 overflow-y-hidden bg-white rounded-4">
                      <table class="table mb-0 text-nowrap table-centered">
                        <thead class="table-light">
                          <tr>
                            <th className="w-10">No.</th>
                            <th className="lh-1 w-60">
                              Details
                              <i className="bi bi-info-circle ms-2 text-dark"></i>
                              <br />
                              <span className="fs-8 fw-normal text-secondary">
                                Displaying Information as per Record
                              </span>
                            </th>
                            <th className="lh-1 w-30">
                              Action
                              <i className="bi bi-person-gear ms-2 text-dark"></i>
                              <br />
                              <span className="fs-8 fw-normal text-secondary">
                                Role-Specific Action Panel
                              </span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentRecords.map((attendance, index) => (
                            <tr>
                              <td>{indexOfFirstRecord + index + 1}.</td>
                              <td className="lh-sm py-4 text-wrap">
                                <span class="text-dark">Date</span> &mdash;{" "}
                                {new Date(attendance.date)
                                  .toLocaleString("en-GB", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                  })
                                  .replace(",", "")}
                                <br />
                                <span class="text-dark">
                                  School
                                </span> &mdash; {attendance?.school?.status}
                                <br />
                                <span class="text-dark">Created By</span>{" "}
                                &mdash; {attendance?.school?.createdBy}
                                {studentData?.transportFacility?.busStop && (
                                  <>
                                    <br />
                                    <span class="text-dark">
                                      Bus Pickup
                                    </span>{" "}
                                    &mdash; {attendance?.busPickup?.status}
                                    <br />
                                    <span class="text-dark">Bus Drop</span>{" "}
                                    &mdash; {attendance?.busDrop?.status}
                                  </>
                                )}
                              </td>
                              <td>
                                <div className="d-flex flex-column gap-1 width-fit-content">
                                  <span class="badge bg-success-soft cursor-pointer px-4 rounded-3 btn-py-sm">
                                    Update
                                  </span>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="col-lg-4">
                    <div className="mb-3">
                      <div className="bg-white rounded-pill">
                        <form
                          className="d-flex align-items-center"
                          onSubmit={(e) => e.preventDefault()}
                        >
                          <span className="position-absolute ps-3 search-icon">
                            <i className="bi bi-filter-circle-fill ms-1" />
                          </span>
                          <input
                            type="search"
                            className="form-control ps-7 rounded-3 border-0 rounded-4"
                            placeholder="Filter Data"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                        </form>
                      </div>
                      <div className="mt-2 ms-4">
                        <nav aria-label="breadcrumb">
                          <ol class="breadcrumb pe-3">
                            <li class="breadcrumb-item">
                              <a href="#">Student Attendance</a>
                            </li>
                            <li
                              class="breadcrumb-item active"
                              aria-current="page"
                            >
                              Attendance
                            </li>
                          </ol>
                        </nav>
                      </div>
                    </div>

                    <div class="p-5 bg-white rounded-4">
                      <div className="d-flex flex-column align-items-center">
                        <div>
                          <div class="icon-shape icon-xxl p-7 border rounded-3 position-relative overflow-hidden me-2">
                            <img
                              src={
                                studentData?.studentDetails?.studentImage ||
                                `/assets/images/profile.png`
                              }
                              alt="Image"
                              width="150"
                              height="150"
                              className="object-fit-cover rounded-3"
                            />
                          </div>
                          <div class="icon-shape icon-xxl p-7 border rounded-3 position-relative">
                            <img
                              src="https://cdn-icons-png.flaticon.com/512/14021/14021384.png"
                              className="w-100 position-absolute p-2 rounded-4"
                              alt="QR"
                            />
                          </div>
                        </div>

                        <div className="mt-3 text-center">
                          <h3 class="m-0 fs-4 lh-sm">
                            {studentData?.studentDetails?.name
                              .toLowerCase()
                              .replace(/\b\w/g, (char) =>
                                char.toUpperCase()
                              )}{" "}
                            ({studentData?.currentClass},{" "}
                            {studentData?.studentDetails?.currentSection})
                          </h3>
                          <p className="m-0">
                            {studentData?.studentDetails?.admission_no},{" "}
                            {new Date(
                              studentData?.studentDetails?.admissionDate
                            ).toLocaleDateString("en-GB")}
                          </p>

                          <p className="mt-1 mb-0 text-danger lh-sm">
                            (+91) {studentData?.parentDetails[0]?.phone}
                            <br />
                            <span className="text-lowercase">
                              {studentData?.parentDetails[0]?.email}
                            </span>
                          </p>
                          <p className="m-0 lh-sm mt-4 text-capitalize">
                            {studentData?.presentAddress?.address
                              .toLowerCase()
                              .replace(/\b\w/g, (char) => char.toUpperCase())}
                            <br />
                            {studentData?.presentAddress?.city} -{" "}
                            {studentData?.presentAddress?.state}
                          </p>
                          <p className="mt-3 mb-0 text-dark lh-sm">
                            Mr.{" "}
                            {studentData?.parentDetails[0]?.name
                              .toLowerCase()
                              .replace(/\b\w/g, (char) => char.toUpperCase())}
                            <br />
                            Mrs.{" "}
                            {studentData?.parentDetails[1]?.name
                              .toLowerCase()
                              .replace(/\b\w/g, (char) => char.toUpperCase())}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="my-4">
                      <nav>
                        <ul className="pagination justify-content-center mb-0">
                          <li
                            className={`page-item ${
                              currentPage === 1 ? "disabled" : ""
                            }`}
                          >
                            <button className="page-link" onClick={prevPage}>
                              <i className="bi bi-chevron-left"></i>
                            </button>
                          </li>

                          {(() => {
                            const pageNumbers = [];
                            pageNumbers.push(1);

                            if (currentPage > 3) {
                              pageNumbers.push("left-ellipsis");
                            }

                            if (
                              currentPage !== 1 &&
                              currentPage !== totalPages
                            ) {
                              pageNumbers.push(currentPage);
                            }

                            if (currentPage < totalPages - 2) {
                              pageNumbers.push("right-ellipsis");
                            }

                            if (totalPages > 1) {
                              pageNumbers.push(totalPages);
                            }

                            return pageNumbers.map((page, index) => {
                              if (
                                page === "left-ellipsis" ||
                                page === "right-ellipsis"
                              ) {
                                return (
                                  <li
                                    key={index}
                                    className="page-item disabled"
                                  >
                                    <span className="page-link">...</span>
                                  </li>
                                );
                              }

                              return (
                                <li
                                  key={index}
                                  className={`page-item ${
                                    currentPage === page ? "active" : ""
                                  }`}
                                >
                                  <button
                                    className="page-link"
                                    onClick={() => setCurrentPage(page)}
                                  >
                                    {page}
                                  </button>
                                </li>
                              );
                            });
                          })()}

                          <li
                            className={`page-item ${
                              currentPage === totalPages ? "disabled" : ""
                            }`}
                          >
                            <button className="page-link" onClick={nextPage}>
                              <i className="bi bi-chevron-right"></i>
                            </button>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </main>
      </div>
    </>
  );
}

export default StudentAttendance;
